import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { StgFollowUpRequest } from '../../types/account'

const { ACCOUNTS_API_URL } = CONSTANT

const submitStgFollowUp = async (payload: StgFollowUpRequest): Promise<unknown> => {
	const response = await fetchWithAuthorizationHeader(`${ACCOUNTS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'stg_onboard'
		},
		body: JSON.stringify(payload)
	})

	return response.json()
}

export default submitStgFollowUp
